import { Outlet } from '@solidjs/router';
import EnsureUnauthenticated from './EnsureUnauthenticated';
const EnsureUnauthenticatedRoutes = () => (<EnsureUnauthenticated>
    <Outlet />
  </EnsureUnauthenticated>);
export default EnsureUnauthenticatedRoutes;
